import ImagineRsrcGroupDelegate from "../analyzer/ImagineRsrcGroupDelegate.js";
import RsrcFilterModelEditor from "./RsrcFilterModelEditor.js";
import RsrcFilterModel from "./RsrcFilterModel.js";
import RsrcSortModel from "./RsrcSortModel.js";
import RsrcSortModelEditor from "./RsrcSortModelEditor.js";
export default {
  install(plg) {
    plg.addPlugin('ConditionFilterModel', {
      delegateType: ImagineRsrcGroupDelegate.TYPE,
      objectType: 'rsrc',
      ...RsrcFilterModel
    });
    plg.addPlugin('Model', {
      type: RsrcFilterModel.TYPE,
      model: RsrcFilterModel
    });
    plg.addPlugin('ModelEditor', {
      type: RsrcFilterModel.TYPE,
      editor: RsrcFilterModelEditor
    });
    plg.addPlugin('SortModel', {
      delegateType: ImagineRsrcGroupDelegate.TYPE,
      objectType: 'rsrc',
      ...RsrcSortModel
    });
    plg.addPlugin('Model', {
      type: RsrcSortModel.TYPE,
      model: RsrcSortModel
    });
    plg.addPlugin('ModelEditor', {
      type: RsrcSortModel.TYPE,
      editor: RsrcSortModelEditor
    });
  }
};